module.exports = __webpack_public_path__ + "static/media/errorScanSound.5aaebaf8.wav";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/sounds/errorScanSound.wav
// module id = 3191
// module chunks = 0